import { FormikProps } from 'formik';

import { PurchaseOrderDetailPositionsFormValues } from '../purchase-order-detail-positions';
import { PurchaseOrderItem } from '../../../models/purchase-order-item';

export const getNextPosition = (formikProps: FormikProps<PurchaseOrderDetailPositionsFormValues>) => {
    return Math.max(0, ...(formikProps.values.allItems as PurchaseOrderItem[]).map(item => item.position ?? 0)) + 1;
};
